import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//- Get All
export const GetAllWhoShouldOpt = createAsyncThunk(
  "careercounselling/whoshouldopt/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.CareerCounselling.WhoShouldOpt}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "whoshouldopt",
  initialState: {
    all_whoshouldopt: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      //GET ALL
      .addCase(GetAllWhoShouldOpt.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllWhoShouldOpt.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whoshouldopt = action.payload?.data || [];
      })
      .addCase(GetAllWhoShouldOpt.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
